import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getExperiments } from '../utils/api';

const statusColor = { running:'#7dd3fc', completed:'#86efac', aborted:'#f87171' };
const statusLabel = { running:'กำลังทดลอง', completed:'เสร็จสิ้น', aborted:'ยกเลิก' };

export default function ExperimentList() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getExperiments()
      .then(({ data }) => setList(data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p style={{ color:'#94a3b8' }}>กำลังโหลด...</p>;

  return (
    <div style={{ maxWidth:900, margin:'0 auto' }}>
      <h1 style={{ fontSize:22, fontWeight:700, marginBottom:20 }}>ผลการทดลองทั้งหมด</h1>

      {!list.length && <p style={{ color:'#64748b' }}>ยังไม่มีการทดลอง</p>}

      <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
        {list.map(exp => (
          <Link key={exp.id} to={`/experiments/${exp.id}`} style={{ textDecoration:'none' }}>
            <div style={{ background:'#1e293b', borderRadius:10, padding:'16px 20px',
              display:'flex', alignItems:'center', justifyContent:'space-between',
              border:'1px solid #334155', transition:'border-color 0.15s',
            }}
              onMouseEnter={e => e.currentTarget.style.borderColor='#38bdf8'}
              onMouseLeave={e => e.currentTarget.style.borderColor='#334155'}
            >
              <div>
                <p style={{ fontWeight:600, fontSize:16, color:'#e2e8f0' }}>#{exp.id} — {exp.title}</p>
                <p style={{ color:'#64748b', fontSize:13, marginTop:4 }}>
                  เริ่ม: {new Date(exp.started_at).toLocaleString('th-TH')}
                  {exp.completed_at && ` | เสร็จ: ${new Date(exp.completed_at).toLocaleString('th-TH')}`}
                  &nbsp;| ระยะเวลา: {exp.duration}s &nbsp;| Log ทุก: {exp.log_interval}s
                </p>
              </div>
              <span style={{ color: statusColor[exp.status] || '#94a3b8', fontWeight:600, fontSize:13 }}>
                {statusLabel[exp.status] || exp.status}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
